"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var fontSizes = {
    "fontsize10": "0.625rem",
    "fontsize12": "0.75rem",
    "fontsize13": "0.8125rem",
    "fontsize14": "0.875rem",
    "fontsize16": "1rem",
    "fontsize20": "1.25rem",
    "fontsize24": "1.5rem",
    "fontsize28": "1.75rem",
    "fontsize32": "2rem",
    "h1": "2rem",
    "h2": "1.75rem",
    "h3": "1.5rem",
    "h4": "1.3125rem",
    "h5": "1.125rem",
    "h6": "1rem",
    "body": "1rem",
    "small": "0.875rem",
    "mini": "0.75rem",
    "code": "1rem",
    "codeSmall": "0.875rem"
};
exports.default = fontSizes;
//# sourceMappingURL=fontSizes.js.map